import type { SettingsNativeBridgeBase } from '../bridge/SettingsNativeBridgeBase';

// Log level types for settings
export const logConstants = {
	INFO: 'info',
	ERROR: 'error',
	DEBUG: 'debug',
} as const;

export type logConstantsType = (typeof logConstants)[keyof typeof logConstants];

// AOT category types for settings
export const AotCategory = {
	Error: '1',
	Info: '2',
	Warning: '64',
	Failure: '128',
} as const;

export type AotCategoryType = (typeof AotCategory)[keyof typeof AotCategory];

// Write trace parameters interface
export interface WriteTraceParams {
	level?: string;
	aotCategory?: AotCategoryType;
	message: string;
	aotMessage?: string;
}

export class SettingsLogger {
	private static instance: SettingsLogger;
	private bridge: SettingsNativeBridgeBase | null = null;

	public static getInstance(): SettingsLogger {
		if (!SettingsLogger.instance) {
			SettingsLogger.instance = new SettingsLogger();
		}
		return SettingsLogger.instance;
	}

	/**
	 * Set the bridge instance for writing logs to native
	 * @param bridge - The native bridge instance
	 */
	public setBridge(bridge: SettingsNativeBridgeBase): void {
		this.bridge = bridge;
	}

	public write(
		level: logConstantsType,
		message: string,
		aotCategory?: AotCategoryType,
		aoTrace?: string
	): void {
		// Send logs to native via bridge's writeTrace method
		const timestamp = new Date().toISOString();
		const logMessage = `[${timestamp}] [${level}] ${message}`;
		switch (level) {
			case 'error':
				console.error(logMessage);
				break;
			case 'debug':
				console.debug(logMessage);
				break;
			case 'info':
			default:
				console.log(logMessage);
				break;
		}
		if (this.bridge) {
			try {
				this.bridge.writeTrace(level, message, aotCategory, aoTrace);
			} catch (error) {
				console.error('Failed to write trace to native:', error);
			}
		}
	}
}
